import { render, staticRenderFns } from "./iframeBI.vue?vue&type=template&id=6198a944&scoped=true&"
import script from "./iframeBI.vue?vue&type=script&lang=js&"
export * from "./iframeBI.vue?vue&type=script&lang=js&"
import style0 from "./iframeBI.vue?vue&type=style&index=0&id=6198a944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6198a944",
  null
  
)

export default component.exports